/**
 * StreakBadgesSection - Display earned streak badges
 */
import { Trophy } from "lucide-react";

const StreakBadgesSection = ({ streakData }) => {
  // Only render if there are claimed rewards
  const claimedRewards = streakData?.rewards?.filter(r => r.claimed) || [];
  
  if (claimedRewards.length === 0) {
    return null;
  }

  return (
    <section 
      className="bg-card rounded-2xl border border-charcoal/5 shadow-card overflow-hidden animate-fade-in" 
      style={{ animationDelay: "0.05s" }}
    >
      <div className="p-6 border-b border-charcoal/5">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full bg-orange-500/10 flex items-center justify-center">
            <Trophy className="w-5 h-5 text-orange-500" />
          </div>
          <div>
            <h2 className="font-serif text-xl font-medium text-charcoal">Streak Badges</h2>
            <p className="text-sm text-muted-foreground">
              {streakData.current_streak} day streak • {claimedRewards.length} badges earned
            </p>
          </div>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex flex-wrap gap-3">
          {claimedRewards.map((reward) => (
            <div
              key={reward.id}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-gradient-to-br from-primary/5 to-secondary/5 border border-primary/20"
            >
              <span className="text-2xl">{reward.emoji}</span>
              <div>
                <p className="font-medium text-charcoal text-sm">{reward.title}</p>
                <p className="text-xs text-muted-foreground">{reward.days}-day streak</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Next reward preview */}
        {streakData.next_reward && (
          <div className="mt-4 p-4 rounded-xl bg-muted/30 border border-dashed border-border">
            <p className="text-sm text-muted-foreground">
              <span className="font-medium text-foreground">Next reward:</span> {streakData.next_reward.emoji} {streakData.next_reward.title}
              <span className="ml-2 text-xs">({streakData.next_reward.days_remaining} days to go)</span>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default StreakBadgesSection;
